import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import "./Slider.scss"

class Slider extends Component {
    constructor() {
        super();
        this.state = {
            currentLocation: -1
        }
    }
    shouldComponentUpdate(props) {
        if (props.currentLocation != this.state.currentLocation) return true;
        return false;
    }
    componentWillReceiveProps(nP) {
        if (nP.currentLocation) {
            window.setTimeout(() => {
                this.setState({
                    currentLocation: nP.currentLocation
                })
            }, 500);
        }
    }
    componentDidMount() {
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('resize');
        } else {
            event = document.createEvent('Event');
            event.initEvent('resize', true, true);
        }
        window.dispatchEvent(event);
        this.props.setOwlRef ? this.props.setOwlRef(this.owl) : null;
    }
    render() {
        return (
            <OwlCarousel
                className={`owl-theme`}
                startPosition={0}
                margin={0}
                nav={true}
                navSpeed={600}
                lazyLoad={true}
                dots={false}
                autoWidth={false}
                responsiveClass={true}
                loop={false}
                ref={(owl) => this.owl = owl}
                navText={["", ""]}
                onChanged={this.props.setNavBar ? this.props.setNavBar : (e) => { }}
                navContainerClass="controller"
                navClass={["arrow right", "arrow left"]}
                responsive={{
                    800: {
                        items: 4,
                        slideBy: 1,
                        center: false,
                        autoWidth: false,
                        rtl: true,
                        nav: true
                    }
                }}
            >
                {this.props.children}
            </OwlCarousel>
        );
    }
}

export default Slider;


// WEBPACK FOOTER //
// ./src/Components/Helpers/Slider/Slider.jsx